export default __webpack_public_path__ + "static/media/ed_3.be327a6c.mp3";